import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import IndustriesPage from "./pages/IndustriesPage";
import CaseStudiesPage from "./pages/CaseStudiesPage";
import BlogPage from "./pages/BlogPage";
import BlogDetailPage from "./pages/BlogDetailPage";
import GrowthAuditPage from "./pages/GrowthAuditPage";
import IndustryDetailPage from "./pages/IndustryDetailPage";
import CaseStudyDetailPage from "./pages/CaseStudyDetailPage";
import NotFound from "./components/common/NotFound";
import { useEffect } from "react";

function App() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname])
  return (
    <div className="app-wrapper">
      <NavBar />
      <main style={{ minHeight: "70vh" }}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route
            path="/industries/:slug"
            element={<IndustryDetailPage />}
          />
          <Route
            path="/case-studies/:slug"
            element={<CaseStudyDetailPage />}
          />
          <Route
            path="/blog/:slug"
            element={<BlogDetailPage />}
          />
          <Route path="/free-growth-audit" element={<GrowthAuditPage />} />
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
export default App;
